namespace GeniuzPOS.Inventory {
    export interface IcStockApproveDisassembleForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.LookupEditor;
        RefDocNo2: Serenity.StringEditor;
        WhsSet: Serenity.LookupEditor;
        WhsItem: Serenity.LookupEditor;
        SetItemCode: Serenity.LookupEditor;
        CallAssemDocFg: Serenity.IntegerEditor;
        SetQty: Serenity.DecimalEditor;
        CalDtQtyFg: Serenity.IntegerEditor;
        ApproveFg: Serenity.EnumEditor;
        Remark: Serenity.StringEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        IcStockApproveDisassembleDtList: IcStockApproveDisassembleDtEditor;
    }

    export class IcStockApproveDisassembleForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockApproveDisassemble';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockApproveDisassembleForm.init)  {
                IcStockApproveDisassembleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.EnumEditor;
                var w6 = IcStockApproveDisassembleDtEditor;

                Q.initFormType(IcStockApproveDisassembleForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'RefDocNo1', w2,
                    'RefDocNo2', w0,
                    'WhsSet', w2,
                    'WhsItem', w2,
                    'SetItemCode', w2,
                    'CallAssemDocFg', w3,
                    'SetQty', w4,
                    'CalDtQtyFg', w3,
                    'ApproveFg', w5,
                    'Remark', w0,
                    'PostFg', w5,
                    'CancelFg', w5,
                    'IcStockApproveDisassembleDtList', w6
                ]);
            }
        }
    }
}
